import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: "",
  transactions: [],
};

export const transactionSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    addTransaction: (state, action) => {
      state.transactions.unshift(action.payload);
    },
    removeTransaction: (state, action) => {
      const { index } = action.payload;
      state.transactions.splice(index, 1);
    },
    syncTransaction: (state, action) => {
      let idx = state.transactions.findIndex(
        (i) => i.created_at == action.payload
      );
      if (idx && idx != -1) {
        state.transactions.splice(idx, 1);
      }
    },
    updateTransaction: (state, action) => {
      const { idx, record } = action.payload;
      state.transactions[idx].credit = record.credit;
      state.transactions[idx].debit = record.debit;
      state.transactions[idx].nameNumber = record.nameNumber;
      state.transactions[idx].date = record.date;
      state.transactions[idx].broughtForward = record.broughtForward;
    },
  },
});

export const {
  syncTransaction,
  addTransaction,
  removeTransaction,
  updateTransaction,
} = transactionSlice.actions;

export default transactionSlice.reducer;
